import { getGuidanceSessionTypeDisplayName } from '@fruitful/guidance';
import type { GuidanceSessionType, SubscriptionProduct } from '@fruitful/types';

import type { MembershipDetails } from '../../entities/entityTypes';

const hasGuidanceCatalog = (
    product: SubscriptionProduct | null | undefined,
): product is SubscriptionProduct => {
    const guidance = product?.guidance;
    if (guidance == null) {
        return false;
    }

    return (
        guidance.onboardingSessions.length > 0 ||
        guidance.generalSessions.length > 0
    );
};

/**
 * Product whose guidance catalog supplies session display names.
 * Prefer the membership product member-app uses, then the Stripe
 * subscription product shown on membership details.
 */
export const getMembershipProduct = (
    membership: Pick<MembershipDetails, 'product' | 'subscription'>,
): SubscriptionProduct | null => {
    const candidates = [
        membership.product,
        membership.subscription?.product,
        membership.subscription?.currentPhase?.product,
    ];

    return (
        candidates.find(hasGuidanceCatalog) ??
        candidates.find(
            (product): product is SubscriptionProduct => product != null,
        ) ??
        null
    );
};

export const getMembershipGuidanceSessionDisplayName = (
    sessionType: `${GuidanceSessionType}`,
    membership: Pick<MembershipDetails, 'product' | 'subscription'>,
): string =>
    getGuidanceSessionTypeDisplayName(
        sessionType,
        getMembershipProduct(membership),
    );
